module.exports = __webpack_public_path__ + "img/Personnage.4bec7193.png";